import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'

const isDev = import.meta.env.DEV;
if (isDev) {
  console.log('🚀 ELOG Frontend - Starting...');
}

// Ensure root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Root element not found!');
  throw new Error('Root element not found!');
}

if (isDev) {
  console.log('✅ Root element found');
}

// Add error handling for rendering
try {
  if (isDev) {
    console.log('📦 Creating React root...');
  }
  const root = createRoot(rootElement);
  
  if (isDev) {
    console.log('🎨 Rendering App component...');
  }
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
  
  if (isDev) {
    console.log('✅ App rendered successfully!');
  }
} catch (error) {
  console.error('❌ Failed to render app:', error);
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif; direction: ltr;">
        <h1 style="color: red;">Application Load Error</h1>
        <p>${error instanceof Error ? error.message : 'An unknown error occurred'}</p>
        <button onclick="window.location.reload()" style="padding: 10px 20px; font-size: 16px; cursor: pointer; background: #1E40AF; color: white; border: none; border-radius: 4px;">
          Reload Application
        </button>
        <pre style="text-align: left; background: #f5f5f5; padding: 10px; margin-top: 20px; overflow: auto; border-radius: 4px;">
          ${error instanceof Error ? error.stack : JSON.stringify(error, null, 2)}
        </pre>
      </div>
    `;
  }
}
